// src/components/Menu.jsx
import React from 'react';
import './Menu.css';
import './MenuItem.css';
import { Link } from "react-router-dom";

const Menu = () => {
  return (
    <div id='menu' className="menu-container">
      <h1 className="menu-title animate-up">Fatburger Menu</h1>

      {/* BURGERS CATEGORY */}
      <div className="menu-category">
        <h2 className="category-title">Burgers</h2>
        <div className="menu-grid">
          <div className="menu-item animate-up" style={{animationDelay: '0.11s'}}>
            <div className="menu-item-content">
              <div className="item-header">
                <h4>Original Fatburger</h4>
                <span className="price">$8.99</span>
              </div>
              <p className="item-description">
                A classic burger with all the fixings, fresh lettuce, tomatoes, and our secret sauce.
              </p>
              <Link to="/explore" onClick={() => window.scrollTo(0, 0)} className="add-cart">Order Now</Link>
            </div>
          </div>
          
          <div className="menu-item animate-up" style={{animationDelay: '0.2s'}}>
            <div className="menu-item-content">
              <div className="item-header">
                <h4>Cheese Fatburger</h4>
                <span className="price">$9.49</span>
              </div>
              <p className="item-description">
                Classic burger with melted cheddar cheese and hand-picked pickles.
              </p>
              <Link to="/explore" onClick={() => window.scrollTo(0, 0)} className="add-cart">Order Now</Link>
            </div>
          </div>
          
          <div className="menu-item animate-up" style={{animationDelay: '0.3s'}}>
            <div className="menu-item-content">
              <div className="item-header">
                <h4>Bacon Fatburger</h4>
                <span className="price">$10.49</span>
              </div>
              <p className="item-description">
                Burger topped with crispy bacon strips and smoky BBQ infusion.
              </p>
              <Link to="/explore" onClick={() => window.scrollTo(0, 0)} className="add-cart">Order Now</Link>
            </div>
          </div>
        </div>
      </div>

      {/* SIDES CATEGORY */}
      <div className="menu-category">
        <h2 className="category-title">Sides</h2>
        <div className="menu-grid">
          <div className="menu-item animate-up" style={{animationDelay: '0.4s'}}>
            <div className="menu-item-content">
              <div className="item-header">
                <h4>Fat Fries</h4>
                <span className="price">$3.49</span>
              </div>
              <p className="item-description">
                Crispy, golden fries made to perfection with a hint of sea salt.
              </p>
              <Link to="/explore" onClick={() => window.scrollTo(0, 0)} className="add-cart">Order Now</Link>
            </div>
          </div>
          
          <div className="menu-item animate-up" style={{animationDelay: '0.5s'}}>
            <div className="menu-item-content">
              <div className="item-header">
                <h4>Onion Rings</h4>
                <span className="price">$3.99</span>
              </div>
              <p className="item-description">
                Crispy, golden onion rings breaded with our signature herb mix.
              </p>
              <Link to="/explore" onClick={() => window.scrollTo(0, 0)} className="add-cart">Order Now</Link>
            </div>
          </div>
        </div>
      </div>

      {/* DRINKS CATEGORY */}
      <div className="menu-category">
        <h2 className="category-title">Drinks</h2>
        <div className="menu-grid">
          <div className="menu-item animate-up" style={{animationDelay: '0.6s'}}>
            <div className="menu-item-content">
              <div className="item-header">
                <h4>Soda</h4>
                <span className="price">$2.49</span>
              </div>
              <p className="item-description">
                Refreshing soda, available in a variety of flavors including Coke and Sprite.
              </p>
              <Link to="/explore" onClick={() => window.scrollTo(0, 0)} className="add-cart">Order Now</Link>
            </div>
          </div>
          
          <div className="menu-item animate-up" style={{animationDelay: '0.7s'}}>
            <div className="menu-item-content">
              <div className="item-header">
                <h4>Milkshake</h4>
                <span className="price">$5.99</span>
              </div>
              <p className="item-description">
                Creamy milkshake available in chocolate, vanilla, or strawberry.
              </p>
              <Link to="/explore" onClick={() => window.scrollTo(0, 0)} className="add-cart">Order Now</Link>
            </div>
          </div>
        </div>
      </div>
    
      <div className="explore-btn-container animate-up" style={{animationDelay: '0.81s'}}>
        <Link to='/explore' onClick={() => window.scrollTo(0, 0)} className="button-gourmet">
          Explore Full Menu
        </Link>
      </div>
    </div>
  );
};

export default Menu;
